






































import { computed, defineComponent, Ref, ref } from '@vue/composition-api';
import cTable                                  from '@/components/table/table.component.vue';
import { GlobalContexts, useGlobals }          from '@/hooks/use-globals';
import cRowActions                             from '@/components/row-actions/row-actions.component.vue';
import { name as vXAxisReportPreview }         from '@/views/x-axis-report/report-edit/views/preview/x-axis-report-preview.route';
import { Computed, ObjectWithStringKeys }      from '@/types';
import { State, XAxisReport }                  from '@/views/x-axis-report/report-list/store/x-axis-report-list.state.store';
import { getViewStorePath }                    from '@/store/store.helpers';
import { nameModeEdit as vXAxisBuilderEdit }   from '@/views/x-axis-report/report-edit/views/builder/x-axis-report-builder.route';
import { name }                                from '../../x-axis-report-list.route';

export default defineComponent({
  name: 'cAxisReportListTable',
  components: {
    cTable,
    cRowActions,
  },
  setup() {
    const { store, router }: GlobalContexts = useGlobals();
    const tableColumns: Ref<string[]> = ref([ 'title', 'creationDate', 'actions' ]);
    const tableData: Computed<XAxisReport[]> = computed(() => (store.state.views.vXAxisReportList as State).reportList);
    const loading: Computed<boolean> = computed(() => (store.state.views.vXAxisReportList as State).loading);
    const removeSpaces = (text: string) => text.replace(/\s/g, '-').toLowerCase();
    const onEditAction = (row: XAxisReport): void => {
      router.push({ name: vXAxisBuilderEdit, params: { xAxisReportUuid: row.uuid } });
    };

    const onDeleteAction = (row: XAxisReport): void => {
      store.dispatch(`${getViewStorePath(name)}/deleteXAxisReport`, row.uuid);
    };

    const getRouterLinkToParam = (xAxisReportUuid: string): { name: string; params: ObjectWithStringKeys<string> } => ({
      name: vXAxisReportPreview,
      params: {
        xAxisReportUuid,
      },
    });

    return {
      tableColumns,
      tableData,
      loading,
      onEditAction,
      onDeleteAction,
      getRouterLinkToParam,
      removeSpaces,
    };
  },
});
